import { FIN_CHE_MANAGEMENT_ITEM } from './fin-che-management.js'
import { FIN_CHE_CALENDAR_ITEM } from './fin-che-calendar.js'
import { FIN_CHE_CHECKBOOKS_ITEM } from './fin-che-checkbooks.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_CHE_HELP = {
  screenId: 'fin-che',
  label: 'Cheques Emitidos',
  navPath: 'Finanzas → Cheques Emitidos',
  keywords: [
    'cheque emitido', 'cheque propio', 'chequera', 'emitir cheque', 'pago cheque',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Gestioná cheques propios: se emiten en Pagos con una chequera registrada acá. Consultá estado, calendario de vencimientos a 30 días y cobros por ventanilla o rechazos.',
  sidebarItems: [FIN_CHE_MANAGEMENT_ITEM, FIN_CHE_CALENDAR_ITEM, FIN_CHE_CHECKBOOKS_ITEM],
}
